exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".logout-view-container .logout-view-container-body {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end; }\n\n.logout-view-container .logout-button {\n  font-size: 0.6rem; }\n", ""]);

